/**
 * Typed bags hung on PIXI objects in the map scene.
 *
 * Inventory (grep-verified):
 * - mapObjectData   MapObject on marker containers
 * - mainMarker      PIXI.Container back-link on quest markers
 * - tickerFunction  ticker callback on highlight/clouds containers
 */
import type * as PIXI from 'pixi.js';
import type { MapObject } from '../../../models/mapObject';

/** Marker container with map-object metadata. */
export interface MapMarkerContainer extends PIXI.Container {
  mapObjectData?: MapObject;
  /** Quest sub-marker points back at the main island marker. */
  mainMarker?: PIXI.Container;
}

/** Display object that stores a ticker callback for later remove(). */
export interface TickerBoundContainer extends PIXI.Container {
  /** Matches {@link PIXI.TickerCallback} so ticker.add/remove accept it. */
  tickerFunction?: PIXI.TickerCallback<void>;
}

export function asMapMarker(obj: PIXI.Container | object | null | undefined): MapMarkerContainer | undefined {
  return obj as MapMarkerContainer | undefined;
}

export function asTickerBound(obj: PIXI.Container | null | undefined): TickerBoundContainer | undefined {
  return obj as TickerBoundContainer | undefined;
}
